import React from "react"
import autobind from "class-autobind"
import Dialog from "material-ui/Dialog"
import FlatButton from "material-ui/FlatButton"
import strings from "../../localization/strings"
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui"
import { IUserRole } from "../../models"
import _ from "lodash"
import AccountStore from "../../stores/AccountStore"

interface IProps {
  selectedRoleIds: string[]
  handleClose(): void
  handleUpdate(roleIds: string[]): void
}
interface IState {
  selectedRoleIds: string[]
  roles: IUserRole[]
}
const styles = {
  columnValue: {
    textAlign: "left",
    cursor: "pointer"
  },
  columnHeader: {
    textAlign: "left"
  },
}

export default class AddRoleDialogForChip extends React.Component<IProps, IState> {
  constructor(props) {
    super(props)
    this.state = {
      roles: AccountStore.getCurrentAccountSettings().UserRoles || [],
      selectedRoleIds: this.props.selectedRoleIds
    }
    autobind(this)
  }

  componentDidMount() {
  }

  render() {
    return (
      <Dialog
        open
        modal
        title={strings.User_Roles}
        actions={[
          <FlatButton
            data-intercom-target={"Btn-Close-RoleId-Selection-Dialog"}
            label={strings.Cancel}
            secondary
            onClick={this.props.handleClose}
          />,
          <FlatButton
            data-intercom-target={"Btn-Save-Selected-RoleId"}
            label={strings.OK}
            primary
            keyboardFocused
            onClick={() => this.props.handleUpdate(this.state.selectedRoleIds)}
          />
        ]}
        onRequestClose={this.props.handleClose}
      >
        <div data-intercom-target={"Role-Selection-Dialog"}>
          <div style={{ textAlign: "center", height: 500 }}>
            <Table
              onCellClick={(rowNumber) => {
                if(this.state.selectedRoleIds.includes(this.state.roles[rowNumber].Id)){
                  this.state.selectedRoleIds.splice(this.state.selectedRoleIds.indexOf(this.state.roles[rowNumber].Id), 1);
                }else{
                  this.state.selectedRoleIds.push(this.state.roles[rowNumber].Id)
                }
                this.setState({ selectedRoleIds: this.state.selectedRoleIds})
              }}
              multiSelectable={true}
            >
              <TableHeader>
                <TableRow>
                  <TableHeaderColumn style={styles.columnHeader}>{strings.Role}</TableHeaderColumn>
                </TableRow>
              </TableHeader>
              <TableBody showRowHover={true} deselectOnClickaway={false}>
                {this.state.roles.map((role, i) =>
                  <TableRow key={role.Id} selected={this.state.selectedRoleIds && this.state.selectedRoleIds.includes(role.Id)}>
                    <TableRowColumn style={styles.columnValue} title={role.Id}>
                      {role.Type}
                    </TableRowColumn>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
        </div>
      </Dialog>
    )
  }
}